/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { MediaImageIndexResponse } from '../types/MediaImageIndex'

/**
 * GET /media/images
 * @see backend/nexus/modules/Organisation/Http/Controllers/MediaImageController.php MediaImageController::index
 */
export async function mediaImageIndex(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<MediaImageIndexResponse>> {
	return axiosInstance.get('/media/images', config)
}
